import React from 'react';
import { Helmet } from 'react-helmet';

const CompanyRichSnippet = (): JSX.Element => (
  <Helmet>
    <script type="application/ld+json">
      {JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'Rapid Formations',
        url: 'https://www.rapidformations.co.uk/',
        logo: 'https://d2zkzcdiu38fde.cloudfront.net/images/d17b483e-8c5c-44d9-9dee-72a4c63cc7b8.png',
        foundingDate: '2013',
        address: {
          '@type': 'PostalAddress',
          streetAddress: '71-75 Shelton Street, Covent Garden',
          addressLocality: 'London',
          postalCode: 'WC2H 9JQ',
          addressRegion: 'Greater London',
          addressCountry: 'GB',
        },
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '+442078719990',
          contactType: 'Customer Support',
          areaServed: 'GB',
          availableLanguage: ['English'],
        },
        sameAs: [
          'https://www.facebook.com/rapidformations/',
          'https://x.com/RapidUKOfficial',
          'https://www.linkedin.com/company/rapid-formations/',
          'https://www.instagram.com/rapidformationsofficial/',
          'https://uk.trustpilot.com/review/www.rapidformations.co.uk',
        ],
      })}
    </script>
  </Helmet>
);

export default CompanyRichSnippet;
